import { WotdFormData } from "../../../beans/api";

export enum WotdFormDataActionEnum {
  REQUEST = "app/WOTDFORMDATA/SAVE/REQUEST",
  SUCCESS = "app/WOTDFORMDATA/SAVE/SUCCESS",
  FAIL = "app/WOTDFORMDATA/SAVE/FAIL",
  SET = "app/WOTDFORMDATA/SET",
  MANAGE = "app/WOTDFORMDATA/MANAGE",
}

export interface IWotdFormDataRequest {
  type: WotdFormDataActionEnum.REQUEST;
  email?: string;
}
export interface IWotdFormDataSuccess {
  type: WotdFormDataActionEnum.SUCCESS;
}
export interface IWotdFormDataFail {
  type: WotdFormDataActionEnum.FAIL;
  err: Error;
}

export interface IWotdFormDataSet {
  type: WotdFormDataActionEnum.SET;
  checkboxes: WotdFormData["words"] | WotdFormData["personalData"];
}

export interface IWotdFormDataManage {
  type: WotdFormDataActionEnum.MANAGE;
  hash?: string;
}

export type WotdFormDataAction =
  | IWotdFormDataRequest
  | IWotdFormDataSuccess
  | IWotdFormDataFail
  | IWotdFormDataSet
  | IWotdFormDataManage;

export function wotdFormDataRequest(email?: string): IWotdFormDataRequest {
  return {
    type: WotdFormDataActionEnum.REQUEST,
    email,
  };
}
export function wotdFormDataSuccess(): IWotdFormDataSuccess {
  return {
    type: WotdFormDataActionEnum.SUCCESS,
  };
}
export function wotdFormDataFail(err: Error): IWotdFormDataFail {
  return {
    type: WotdFormDataActionEnum.FAIL,
    err,
  };
}
export function wotdFormDataSet(
  checkboxes: WotdFormData["words"] | WotdFormData["personalData"],
): IWotdFormDataSet {
  return {
    type: WotdFormDataActionEnum.SET,
    checkboxes,
  };
}

export function wotdFormDataManage(hash?: string): IWotdFormDataManage {
  return {
    type: WotdFormDataActionEnum.MANAGE,
    hash,
  };
}
